export default "__VITE_ASSET__BWz1PSQQ__"